import { useState, useCallback, ChangeEvent, KeyboardEvent } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
// import { useMutation } from '@apollo/client';
import { toast } from 'react-toastify';

import * as A from '@pages/Auth/Auth.style';
import theme from '@styles/theme';
import useEnter from '@hooks/useEnter';
import { onlyNumber } from '@utils/common';
// import { Mutation } from '@graphql/types';
// import { FIND_ADMIN_PW } from '@graphql/mutations';
import { validateFindPw } from '@utils/validation';

import StyledInput from '@components/styled/StyledInput';
import StyledButton from '@components/styled/StyledButton';

const ResetPassword = () => {
    const navigate = useNavigate();
    const onEnter = useEnter();
    const { pathname } = useLocation();
    const [loading, setLoading] = useState(false);
    const [verifyCellphone, setVerifyCellphone] = useState(false);
    const [inputs, setInputs] = useState({
        email: '',
        license: '',
        name: '',
        cellphone: '',
        verifyCode: ''
    });

    // const [findAdminPw] =
    //     useMutation<Pick<Mutation, 'findAdminPw'>>(FIND_ADMIN_PW);

    const onChange = useCallback(
        (e: ChangeEvent<HTMLInputElement>) => {
            const { name, value } = e.target;
            if (name === 'license' || name === 'cellphone') {
                return setInputs({
                    ...inputs,
                    [name]: onlyNumber(value)
                });
            }
            setInputs({
                ...inputs,
                [name]: value
            });
        },
        [inputs]
    );

    const handleVerifyCellphone = () => {
        try {
            setVerifyCellphone(true);
        } catch (err) {
            console.error(err);
        }
    };
    const handleSubmit = async () => {
        if (!validateFindPw(inputs, verifyCellphone)) return;

        // const { email, name, cellphone } = inputs;

        setLoading(true);

        try {
            toast.success('임시 비밀번호가 이메일로 전송되었습니다.');
            navigate('/auth/login', { replace: true });
            // await findAdminPw({
            //     variables: {
            //         account: email,
            //         name,
            //         cellphone
            //     },
            //     onCompleted: () => {
            //         toast.success('임시 비밀번호가 이메일로 전송되었습니다.');
            //         navigate('/');
            //     }
            // });
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <A.Wrapper>
            <A.Title>비밀번호를 잊으셨나요?</A.Title>
            <A.SubTitle>
                {`등록된 이메일, 요양기관번호, 대표자명을 입력해주세요`}
            </A.SubTitle>
            <StyledInput
                value={inputs.email}
                name="email"
                onChange={onChange}
                placeholder="등록된 이메일을 입력해주세요"
                margin="0 0 8px"
                borderRadius={0}
            />
            <StyledInput
                value={inputs.license}
                name="license"
                onChange={onChange}
                placeholder="요양기관번호를 입력해주세요"
                maxLength={8}
                margin="0 0 8px"
                borderRadius={0}
            />
            <StyledInput
                value={inputs.name}
                name="name"
                onChange={onChange}
                onKeyDown={(e: KeyboardEvent<HTMLInputElement>) =>
                    onEnter(e, handleSubmit)
                }
                placeholder="대표자명을 입력해주세요"
                maxLength={13}
                borderRadius={0}
            />
            <StyledButton
                title="1회용 비밀번호 발급하기"
                margin="32px 0"
                width={343}
                fontSize={14}
                fontFamily="PretendardRegular"
                onClick={handleSubmit}
                borderRadius={0}
                bgColor={theme.colors.pointBlue}
                loading={loading}
            />
        </A.Wrapper>
    );
};

export default ResetPassword;
